import { DateTime } from "luxon";

const dateString = (date) => {
  const dt = DateTime.fromISO(date);
  // return `${convertMonth(month)} ${day}, ${year}`;
  return dt.toLocaleString(DateTime.DATE_FULL);
};

export default dateString;
